'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Job;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _config = require('config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'job';

function Job(_ref) {
  var matches = _ref.matches,
      title = _ref.title,
      content = _ref.content,
      subsectors = _ref.subsectors,
      fullSlug = _ref.fullSlug;
  var match = matches.match,
      interestMatch = matches.interest,
      skillMatch = matches.skills,
      educationMatch = matches.education;


  var iconFacebook = require('shared/images/icons/icon-facebook.png');
  return _react2.default.createElement(
    'div',
    {
      className: CLASS_NAME
    },
    _react2.default.createElement(
      'div',
      { className: CLASS_NAME + '-match' },
      (match * 100).toFixed(0),
      '%',
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'label',
        null,
        'match'
      ),
      _react2.default.createElement(
        'div',
        { className: 'c-tooltip white' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'a',
            { href: 'https://www.facebook.com/sharer/sharer.php?u=' + _config.HOST + ':' + _config.PORT + fullSlug },
            'Share this',
            _react2.default.createElement('br', null),
            _react2.default.createElement('img', { src: iconFacebook, alt: 'Share on Facebook' })
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: CLASS_NAME + '-info' },
      _react2.default.createElement(
        'h3',
        null,
        _react2.default.createElement(
          'span',
          null,
          'Job:'
        ),
        '\xA0',
        _react2.default.createElement(
          _reactRouter.Link,
          { to: fullSlug },
          title
        )
      ),
      _react2.default.createElement(
        'h4',
        null,
        _react2.default.createElement(
          'span',
          null,
          'See Job In:\xA0'
        ),
        subsectors.map(function (sector) {
          return _react2.default.createElement(
            _reactRouter.Link,
            {
              key: sector.fullSlug,
              to: sector.fullSlug
            },
            sector.label
          );
        })
      ),
      _react2.default.createElement(
        'div',
        {
          className: CLASS_NAME + '-content' },
        content
      ),
      _react2.default.createElement(
        'div',
        { className: CLASS_NAME + '-stats' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            Math.floor(skillMatch),
            '/4'
          ),
          _react2.default.createElement('br', null),
          'Skills'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            (interestMatch * 100).toFixed(0),
            '%'
          ),
          _react2.default.createElement('br', null),
          'Interests'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            educationMatch,
            '%'
          ),
          _react2.default.createElement('br', null),
          'Education'
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Matcher/components/Jobs/Job.jsx
// module id = 1234
// module chunks = 0